// PrestigeSystem — awards Estrellas del Club: weekly checks for the
// state-derived milestones, plus the event-driven Major star. Each star is
// permanent and feeds the modifier engine as a small income boost.

import { EventBus, GameEvents, type CircuitEventResolvedPayload } from '../utils/EventBus'
import { useGameStore } from '@/store/gameStore'
import { checkStateMilestones, getStarMilestone } from '@/config/prestigeConfig'

export class PrestigeSystem {
  private weekHandler = () => this.checkMilestones()
  private circuitHandler = (payload: CircuitEventResolvedPayload) => {
    if (payload.champion && payload.tier === 'Premier Padel Major') {
      this.award('major_champion')
    }
  }

  constructor() {
    EventBus.on(GameEvents.WEEK_CHANGED, this.weekHandler)
    EventBus.on(GameEvents.CIRCUIT_EVENT_RESOLVED, this.circuitHandler)
  }

  destroy() {
    EventBus.off(GameEvents.WEEK_CHANGED, this.weekHandler)
    EventBus.off(GameEvents.CIRCUIT_EVENT_RESOLVED, this.circuitHandler)
  }

  private checkMilestones() {
    const store = useGameStore.getState()
    for (const id of checkStateMilestones(store)) {
      this.award(id)
    }
  }

  private award(id: string) {
    const store = useGameStore.getState()
    if (store.clubStars.includes(id)) return
    const milestone = getStarMilestone(id)
    if (!milestone) return

    store.awardClubStar(id)
    EventBus.emit(GameEvents.NOTIFY, {
      message: `⭐ Estrella del Club: ${milestone.emoji} ${milestone.name} — ${milestone.description} (+2% ingresos permanente)`,
      type: 'success',
    })
  }
}
